import { BlockDataAttributes } from '@unifyapps/carbon/no-code/hooks/useBlockDataAttributes';
import { toBlob } from 'html-to-image';

const filterExportIgnoredNodes = (node: Node): boolean => {
  if (!(node instanceof HTMLElement)) {
    return true;
  }
  const ignoreSelectors = ['[data-export-ignore="true"]'];
  return !ignoreSelectors.some((selector) => node.closest(selector));
};

export async function copyBlock(blockId?: string) {
  try {
    const blockEl = document.querySelector<HTMLElement>(
      `[${BlockDataAttributes.BlockId}="${blockId}"]`,
    );

    if (!blockEl) {
      console.error('Copy block failed: block element not found');
      return Promise.reject();
    }

    await navigator.clipboard.write([
      new ClipboardItem({
        'image/png': toBlob(blockEl, { filter: filterExportIgnoredNodes }) as Promise<Blob>,
      }),
    ]);

    return Promise.resolve();
  } catch (error) {
    console.error('Copy block failed', error);
    return Promise.reject();
  }
}
